export default "__VITE_ASSET__27f614c3__"